// extracted by mini-css-extract-plugin
export default {"wrapper":"FormMultiSelect_wrapper__IT4fa","trigger":"FormMultiSelect_trigger__sOYCE","triggerError":"FormMultiSelect_triggerError__xeY7b"};